import { useQuery } from '@apollo/client/react';
import { useMemo } from 'react';
import { GET_PROJECT_EVM } from '../graphql/evmQueries';

interface ProjectEVMResponse {
  baseProject: {
    id: string | number;
    evm: any;
  };
}

export const useProjectEVM = (projectId: string | number) => {
  const { data, loading, error, refetch } = useQuery<ProjectEVMResponse>(GET_PROJECT_EVM, {
    variables: { id: projectId.toString() },
    skip: !projectId,
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
  });

  const evm = useMemo(() => {
    return data?.baseProject?.evm || [];
  }, [data]);

  return {
    evm,
    loading,
    error,
    refetch,
  };
};
